module.exports = __webpack_public_path__ + "img/illustration_tournage.0933d5b0.jpg";